import { ApplicationSettings } from '../store/schema/ApplicationSettings';
import { getLocalOverrides } from './localOverrides';

export default function createApplicationSettingsDefaultOverrides(
    defaultApplicationSettings: ApplicationSettings,
    useLocalOverrides = true
): ApplicationSettings {
    const overrides = {};
    const localOverrides = getLocalOverrides();

    Object.keys(defaultApplicationSettings).forEach(group => {
        const settings = defaultApplicationSettings[group];
        const localSettingsOverrides = localOverrides[group];
        overrides[group] = {};

        Object.keys(settings).forEach(setting => {
            overrides[group][setting] =
                useLocalOverrides && localSettingsOverrides?.hasOwnProperty(setting)
                    ? localSettingsOverrides[setting]
                    : undefined;
        });
    });

    return overrides as ApplicationSettings;
}
